var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-app":_vm.$isCN ? 'true' : null}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }